import React from "react";

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
	MainHeaderButtonsWrapper: {
		flex: "none",
		marginLeft: "auto",
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
		"& .MuiButton-root": {
			height: 40,
		},
	},
}));

const MainHeaderButtonsWrapper = ({ children }) => {
	const { classes } = useStyles();

	return <div className={classes.MainHeaderButtonsWrapper}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
